import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Button } from "reactstrap";

import { templateQuestionApi } from '../../reducers/templateQuestionSlice';

const NewQuestionPopup = ({ maxWeight, template, onToggle }) => {
    const [body, setBody] = useState()
    const dispatch = useDispatch()

    const onModalToggle = () => {
        onToggle()
    }

    const onSave = () => {
        if(body && body.length > 0) {
            dispatch(templateQuestionApi.create({ 
                templateId: template.id,
                question: {
                    body: body,
                    weight: (maxWeight + 10)
                }
            }))
        }
        onToggle()
    }

    return (
        <Modal
            isOpen={true}
            toggle={() => { onModalToggle() }}
        >
            <ModalHeader toggle={() => { onModalToggle() }}>
                <b>Nuova domanda</b>
            </ModalHeader>
            <ModalBody>
                <Input type="textarea" rows="2" value={body} onChange={(event) => setBody(event.target.value)}/>
            </ModalBody>
            <ModalFooter>
                <Button id="new_question_btn" color="primary" style={{whiteSpace: "nowrap"}} onClick={() => { onSave() }} >
                    <span className="fas fa-check"></span> SALVA
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default NewQuestionPopup;